module.exports = __webpack_public_path__ + "static/media/introCoffeeImage.fb6b476b.JPG";